import { CHUNK_SIZE } from "../../sim/world/constants";
import type { ChunkPos, WorldView } from "../../sim/world/types";
import { PADDED_CHUNK_SIZE, paddedIndex, type BlockMeshDef, type MeshingInput } from "./types";
import { createMeshingTables } from "./types";

export function buildMeshingInput(
  world: WorldView,
  position: ChunkPos,
  definitions: readonly BlockMeshDef[],
): MeshingInput {
  const blocks = new Uint16Array(PADDED_CHUNK_SIZE ** 3);
  const light = new Uint16Array(PADDED_CHUNK_SIZE ** 3);
  const ox = position.cx * CHUNK_SIZE;
  const oy = position.cy * CHUNK_SIZE;
  const oz = position.cz * CHUNK_SIZE;
  for (let y = -1; y <= CHUNK_SIZE; y += 1) {
    for (let z = -1; z <= CHUNK_SIZE; z += 1) {
      for (let x = -1; x <= CHUNK_SIZE; x += 1) {
        const index = paddedIndex(x + 1, y + 1, z + 1);
        blocks[index] = world.getBlock(ox + x, oy + y, oz + z);
        light[index] = world.getLight(ox + x, oy + y, oz + z);
      }
    }
  }
  return { position, blocks, light, tables: createMeshingTables(definitions) };
}
